!function (e) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).numbro = e();
  }
}(function () {
  return function a(o, u, c) {
    function s(t, e) {
      if (!u[t]) {
        if (!o[t]) {
          var r = "function" == typeof require && require;
          if (!e && r) return r(t, !0);
          if (l) return l(t, !0);
          var n = new Error("Cannot find module '" + t + "'");
          throw n.code = "MODULE_NOT_FOUND", n;
        }

        var i = u[t] = {
          exports: {}
        };
        o[t][0].call(i.exports, function (e) {
          return s(o[t][1][e] || e);
        }, i, i.exports, a, o, u, c);
      }

      return u[t].exports;
    }

    for (var l = "function" == typeof require && require, e = 0; e < c.length; e++) {
      s(c[e]);
    }

    return s;
  }({
    1: [function (e, r, t) {
      !function (e) {
        "use strict";

        var t,
            k = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
            _ = Math.ceil,
            L = Math.floor,
            T = "[BigNumber Error] ",
            P = T + "Number primitive has more than 15 significant digits: ",
            U = 1e14,
            j = 14,
            C = 9007199254740991,
            R = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
            I = 1e7,
            $ = 1e9;

        function G(e) {
          var t = 0 | e;
          return 0 < e || e === t ? t : t - 1;
        }

        function V(e) {
          for (var t, r, n = 1, i = e.length, a = e[0] + ""; n < i;) {
            for (t = e[n++] + "", r = j - t.length; r--; t = "0" + t) {
              ;
            }

            a += t;
          }

          for (i = a.length; 48 === a.charCodeAt(--i);) {
            ;
          }

          return a.slice(0, i + 1 || 1);
        }

        function q(e, t) {
          var r,
              n,
              i = e.c,
              a = t.c,
              o = e.s,
              u = t.s,
              c = e.e,
              s = t.e;
          if (!o || !u) return null;
          if (r = i && !i[0], n = a && !a[0], r || n) return r ? n ? 0 : -u : o;
          if (o != u) return o;
          if (r = o < 0, n = c == s, !i || !a) return n ? 0 : !i ^ r ? 1 : -1;
          if (!n) return s < c ^ r ? 1 : -1;

          for (u = (c = i.length) < (s = a.length) ? c : s, o = 0; o < u; o++) {
            if (i[o] != a[o]) return i[o] > a[o] ^ r ? 1 : -1;
          }

          return c == s ? 0 : s < c ^ r ? 1 : -1;
        }

        function Z(e, t, r, n) {
          if (e < t || r < e || e !== (e < 0 ? _(e) : L(e))) throw Error(T + (n || "Argument") + ("number" == typeof e ? e < t || r < e ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
        }

        function z(e) {
          var t = e.c.length - 1;
          return G(e.e / j) == t && e.c[t] % 2 != 0;
        }

        function W(e, t) {
          return (1 < e.length ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
        }

        function H(e, t, r) {
          var n, i;

          if (t < 0) {
            for (i = r + "."; ++t; i += r) {
              ;
            }

            e = i + e;
          } else if (++t > (n = e.length)) {
            for (i = r, t -= n; --t; i += r) {
              ;
            }

            e += i;
          } else t < n && (e = e.slice(0, t) + "." + e.slice(t));

          return e;
        }

        (t = function e(t) {
          var y,
              f,
              p,
              r,
              s,
              o,
              u,
              c,
              l,
              g,
              n = A.prototype = {
            constructor: A,
            toString: null,
            valueOf: null
          },
              d = new A(1),
              b = 20,
              w = 4,
              h = -7,
              v = 21,
              m = -1e7,
              O = 1e7,
              x = !1,
              a = 1,
              S = 0,
              N = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: " ",
            suffix: ""
          },
              M = "0123456789abcdefghijklmnopqrstuvwxyz";

          function A(e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l = this;
            if (!(l instanceof A)) return new A(e, t);

            if (null == t) {
              if (e instanceof A) return l.s = e.s, l.e = e.e, void (l.c = (e = e.c) ? e.slice() : e);

              if ((u = "number" == typeof e) && 0 * e == 0) {
                if (l.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                  for (a = 0, o = e; 10 <= o; o /= 10, a++) {
                    ;
                  }

                  return l.e = a, void (l.c = [e]);
                }

                s = String(e);
              } else {
                if (s = String(e), !k.test(s)) return p(l, s, u);
                l.s = 45 == s.charCodeAt(0) ? (s = s.slice(1), -1) : 1;
              }

              -1 < (a = s.indexOf(".")) && (s = s.replace(".", "")), 0 < (o = s.search(/e/i)) ? (a < 0 && (a = o), a += +s.slice(o + 1), s = s.substring(0, o)) : a < 0 && (a = s.length);
            } else {
              if (Z(t, 2, M.length, "Base"), s = String(e), 10 == t) return E(l = new A(e instanceof A ? e : s), b + l.e + 1, w);

              if (u = "number" == typeof e) {
                if (0 * e != 0) return p(l, s, u, t);
                if (l.s = 1 / e < 0 ? (s = s.slice(1), -1) : 1, A.DEBUG && 15 < s.replace(/^0\.0*|\./, "").length) throw Error(P + e);
                u = !1;
              } else l.s = 45 === s.charCodeAt(0) ? (s = s.slice(1), -1) : 1;

              for (r = M.slice(0, t), a = o = 0, c = s.length; o < c; o++) {
                if (r.indexOf(n = s.charAt(o)) < 0) {
                  if ("." == n) {
                    if (a < o) {
                      a = c;
                      continue;
                    }
                  } else if (!i && (s == s.toUpperCase() && (s = s.toLowerCase()) || s == s.toLowerCase() && (s = s.toUpperCase()))) {
                    i = !0, o = -1, a = 0;
                    continue;
                  }

                  return p(l, String(e), u, t);
                }
              }

              -1 < (a = (s = f(s, t, 10, l.s)).indexOf(".")) ? s = s.replace(".", "") : a = s.length;
            }

            for (o = 0; 48 === s.charCodeAt(o); o++) {
              ;
            }

            for (c = s.length; 48 === s.charCodeAt(--c);) {
              ;
            }

            if (s = s.slice(o, ++c)) {
              if (c -= o, u && A.DEBUG && 15 < c && (C < e || e !== L(e))) throw Error(P + l.s * e);
              if (O < (a = a - o - 1)) l.c = l.e = null;else if (a < m) l.c = [l.e = 0];else {
                if (l.e = a, l.c = [], o = (a + 1) % j, a < 0 && (o += j), o < c) {
                  for (o && l.c.push(+s.slice(0, o)), c -= j; o < c;) {
                    l.c.push(+s.slice(o, o += j));
                  }

                  s = s.slice(o), o = j - s.length;
                } else o -= c;

                for (; o--; s += "0") {
                  ;
                }

                l.c.push(+s);
              }
            } else l.c = [l.e = 0];
          }

          function i(e, t, r, n) {
            var i, a, o, u, c;
            if (null == r ? r = w : Z(r, 0, 8), !e.c) return e.toString();
            if (i = e.c[0], o = e.e, null == t) c = V(e.c), c = 1 == n || 2 == n && (o <= h || v <= o) ? W(c, o) : H(c, o, "0");else if (a = (e = E(new A(e), t, r)).e, u = (c = V(e.c)).length, 1 == n || 2 == n && (t <= a || a <= h)) {
              for (; u < t; c += "0", u++) {
                ;
              }

              c = W(c, a);
            } else if (t -= o, c = H(c, a, "0"), u < a + 1) {
              if (0 < --t) for (c += "."; t--; c += "0") {
                ;
              }
            } else if (0 < (t += a - u)) for (a + 1 == u && (c += "."); t--; c += "0") {
              ;
            }
            return e.s < 0 && i ? "-" + c : c;
          }

          function B(e, t) {
            for (var r, n = 1, i = new A(e[0]); n < e.length; n++) {
              if (!(r = new A(e[n])).s) {
                i = r;
                break;
              }

              t.call(i, r) && (i = r);
            }

            return i;
          }

          function D(e, t, r) {
            for (var n = 1, i = t.length; !t[--i]; t.pop()) {
              ;
            }

            for (i = t[0]; 10 <= i; i /= 10, n++) {
              ;
            }

            return (r = n + r * j - 1) > O ? e.c = e.e = null : e.c = r < m ? [e.e = 0] : (e.e = r, t), e;
          }

          function E(e, t, r, n) {
            var i,
                a,
                o,
                u,
                c,
                s,
                l,
                f = e.c,
                p = R;

            if (f) {
              e: {
                for (i = 1, u = f[0]; 10 <= u; u /= 10, i++) {
                  ;
                }

                if ((a = t - i) < 0) a += j, o = t, l = (c = f[s = 0]) / p[i - o - 1] % 10 | 0;else if ((s = _((a + 1) / j)) >= f.length) {
                  if (!n) break e;

                  for (; f.length <= s; f.push(0)) {
                    ;
                  }

                  c = l = 0, o = (a %= j) - j + (i = 1);
                } else {
                  for (c = u = f[s], i = 1; 10 <= u; u /= 10, i++) {
                    ;
                  }

                  l = (o = (a %= j) - j + i) < 0 ? 0 : c / p[i - o - 1] % 10 | 0;
                }
                if (n = n || t < 0 || null != f[s + 1] || (o < 0 ? c : c % p[i - o - 1]), n = r < 4 ? (l || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : 5 < l || 5 == l && (4 == r || n || 6 == r && (0 < a ? 0 < o ? c / p[i - o] : 0 : f[s - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, n ? (t -= e.e + 1, f[0] = p[(j - t % j) % j], e.e = -t || 0) : f[0] = e.e = 0, e;
                if (0 == a ? (f.length = s, u = 1, s--) : (f.length = s + 1, u = p[j - a], f[s] = 0 < o ? L(c / p[i - o] % p[o]) * u : 0), n) for (;;) {
                  if (0 == s) {
                    for (a = 1, o = f[0]; 10 <= o; o /= 10, a++) {
                      ;
                    }

                    for (o = f[0] += u, u = 1; 10 <= o; o /= 10, u++) {
                      ;
                    }

                    a != u && (e.e++, f[0] == U && (f[0] = 1));
                    break;
                  }

                  if (f[s] += u, f[s] != U) break;
                  f[s--] = 0, u = 1;
                }

                for (a = f.length; 0 === f[--a]; f.pop()) {
                  ;
                }
              }

              e.e > O ? e.c = e.e = null : e.e < m && (e.c = [e.e = 0]);
            }

            return e;
          }

          function F(e) {
            var t,
                r = e.e;
            return null === r ? e.toString() : (t = V(e.c), t = r <= h || v <= r ? W(t, r) : H(t, r, "0"), e.s < 0 ? "-" + t : t);
          }

          return A.clone = e, A.ROUND_UP = 0, A.ROUND_DOWN = 1, A.ROUND_CEIL = 2, A.ROUND_FLOOR = 3, A.ROUND_HALF_UP = 4, A.ROUND_HALF_DOWN = 5, A.ROUND_HALF_EVEN = 6, A.ROUND_HALF_CEIL = 7, A.ROUND_HALF_FLOOR = 8, A.EUCLID = 9, A.config = A.set = function (e) {
            var t, r;

            if (null != e) {
              if ("object" != typeof e) throw Error(T + "Object expected: " + e);
              if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (Z(r = e[t], 0, $, t), b = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (Z(r = e[t], 0, 8, t), w = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (Z(r[0], -$, 0, t), Z(r[1], 0, $, t), h = r[0], v = r[1]) : (Z(r, -$, $, t), h = -(v = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) if ((r = e[t]) && r.pop) Z(r[0], -$, -1, t), Z(r[1], 1, $, t), m = r[0], O = r[1];else {
                if (Z(r, -$, $, t), !r) throw Error(T + t + " cannot be zero: " + r);
                m = -(O = r < 0 ? -r : r);
              }

              if (e.hasOwnProperty(t = "CRYPTO")) {
                if ((r = e[t]) !== !!r) throw Error(T + t + " not true or false: " + r);

                if (r) {
                  if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw x = !r, Error(T + "crypto unavailable");
                  x = r;
                } else x = r;
              }

              if (e.hasOwnProperty(t = "MODULO_MODE") && (Z(r = e[t], 0, 9, t), a = r), e.hasOwnProperty(t = "POW_PRECISION") && (Z(r = e[t], 0, $, t), S = r), e.hasOwnProperty(t = "FORMAT")) {
                if ("object" != typeof (r = e[t])) throw Error(T + t + " not an object: " + r);
                N = r;
              }

              if (e.hasOwnProperty(t = "ALPHABET")) {
                if ("string" != typeof (r = e[t]) || /^.$|[+-.\s]|(.).*\1/.test(r)) throw Error(T + t + " invalid: " + r);
                M = r;
              }
            }

            return {
              DECIMAL_PLACES: b,
              ROUNDING_MODE: w,
              EXPONENTIAL_AT: [h, v],
              RANGE: [m, O],
              CRYPTO: x,
              MODULO_MODE: a,
              POW_PRECISION: S,
              FORMAT: N,
              ALPHABET: M
            };
          }, A.isBigNumber = function (e) {
            return e instanceof A || e && !0 === e._isBigNumber || !1;
          }, A.maximum = A.max = function () {
            return B(arguments, n.lt);
          }, A.minimum = A.min = function () {
            return B(arguments, n.gt);
          }, A.random = (r = 9007199254740992, s = Math.random() * r & 2097151 ? function () {
            return L(Math.random() * r);
          } : function () {
            return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
          }, function (e) {
            var t,
                r,
                n,
                i,
                a,
                o = 0,
                u = [],
                c = new A(d);
            if (null == e ? e = b : Z(e, 0, $), i = _(e / j), x) if (crypto.getRandomValues) {
              for (t = crypto.getRandomValues(new Uint32Array(i *= 2)); o < i;) {
                9e15 <= (a = 131072 * t[o] + (t[o + 1] >>> 11)) ? (r = crypto.getRandomValues(new Uint32Array(2)), t[o] = r[0], t[o + 1] = r[1]) : (u.push(a % 1e14), o += 2);
              }

              o = i / 2;
            } else {
              if (!crypto.randomBytes) throw x = !1, Error(T + "crypto unavailable");

              for (t = crypto.randomBytes(i *= 7); o < i;) {
                9e15 <= (a = 281474976710656 * (31 & t[o]) + 1099511627776 * t[o + 1] + 4294967296 * t[o + 2] + 16777216 * t[o + 3] + (t[o + 4] << 16) + (t[o + 5] << 8) + t[o + 6]) ? crypto.randomBytes(7).copy(t, o) : (u.push(a % 1e14), o += 7);
              }

              o = i / 7;
            }
            if (!x) for (; o < i;) {
              (a = s()) < 9e15 && (u[o++] = a % 1e14);
            }

            for (i = u[--o], e %= j, i && e && (a = R[j - e], u[o] = L(i / a) * a); 0 === u[o]; u.pop(), o--) {
              ;
            }

            if (o < 0) u = [n = 0];else {
              for (n = -1; 0 === u[0]; u.splice(0, 1), n -= j) {
                ;
              }

              for (o = 1, a = u[0]; 10 <= a; a /= 10, o++) {
                ;
              }

              o < j && (n -= j - o);
            }
            return c.e = n, c.c = u, c;
          }), A.sum = function () {
            for (var e = 1, t = arguments, r = new A(t[0]); e < t.length;) {
              r = r.plus(t[e++]);
            }

            return r;
          }, f = function () {
            var v = "0123456789";

            function m(e, t, r, n) {
              for (var i, a, o = [0], u = 0, c = e.length; u < c;) {
                for (a = o.length; a--; o[a] *= t) {
                  ;
                }

                for (o[0] += n.indexOf(e.charAt(u++)), i = 0; i < o.length; i++) {
                  o[i] > r - 1 && (null == o[i + 1] && (o[i + 1] = 0), o[i + 1] += o[i] / r | 0, o[i] %= r);
                }
              }

              return o.reverse();
            }

            return function (e, t, r, n, i) {
              var a,
                  o,
                  u,
                  c,
                  s,
                  l,
                  f,
                  p,
                  g = e.indexOf("."),
                  h = b,
                  d = w;

              for (0 <= g && (c = S, S = 0, e = e.replace(".", ""), l = (p = new A(t)).pow(e.length - g), S = c, p.c = m(H(V(l.c), l.e, "0"), 10, r, v), p.e = p.c.length), u = c = (f = m(e, t, r, i ? (a = M, v) : (a = v, M))).length; 0 == f[--c]; f.pop()) {
                ;
              }

              if (!f[0]) return a.charAt(0);
              if (g < 0 ? --u : (l.c = f, l.e = u, l.s = n, f = (l = y(l, p, h, d, r)).c, s = l.r, u = l.e), g = f[o = u + h + 1], c = r / 2, s = s || o < 0 || null != f[o + 1], s = d < 4 ? (null != g || s) && (0 == d || d == (l.s < 0 ? 3 : 2)) : c < g || g == c && (4 == d || s || 6 == d && 1 & f[o - 1] || d == (l.s < 0 ? 8 : 7)), o < 1 || !f[0]) e = s ? H(a.charAt(1), -h, a.charAt(0)) : a.charAt(0);else {
                if (f.length = o, s) for (--r; ++f[--o] > r;) {
                  f[o] = 0, o || (++u, f = [1].concat(f));
                }

                for (c = f.length; !f[--c];) {
                  ;
                }

                for (g = 0, e = ""; g <= c; e += a.charAt(f[g++])) {
                  ;
                }

                e = H(e, u, a.charAt(0));
              }
              return e;
            };
          }(), y = function () {
            function M(e, t, r) {
              var n,
                  i,
                  a,
                  o,
                  u = 0,
                  c = e.length,
                  s = t % I,
                  l = t / I | 0;

              for (e = e.slice(); c--;) {
                u = ((i = s * (a = e[c] % I) + (n = l * a + (o = e[c] / I | 0) * s) % I * I + u) / r | 0) + (n / I | 0) + l * o, e[c] = i % r;
              }

              return u && (e = [u].concat(e)), e;
            }

            function B(e, t, r, n) {
              var i, a;
              if (r != n) a = n < r ? 1 : -1;else for (i = a = 0; i < r; i++) {
                if (e[i] != t[i]) {
                  a = e[i] > t[i] ? 1 : -1;
                  break;
                }
              }
              return a;
            }

            function D(e, t, r, n) {
              for (var i = 0; r--;) {
                e[r] -= i, i = e[r] < t[r] ? 1 : 0, e[r] = i * n + e[r] - t[r];
              }

              for (; !e[0] && 1 < e.length; e.splice(0, 1)) {
                ;
              }
            }

            return function (e, t, r, n, i) {
              var a,
                  o,
                  u,
                  c,
                  s,
                  l,
                  f,
                  p,
                  g,
                  h,
                  d,
                  v,
                  m,
                  y,
                  b,
                  w,
                  O,
                  x = e.s == t.s ? 1 : -1,
                  S = e.c,
                  N = t.c;
              if (!(S && S[0] && N && N[0])) return new A(e.s && t.s && (S ? !N || S[0] != N[0] : N) ? S && 0 == S[0] || !N ? 0 * x : x / 0 : NaN);

              for (g = (p = new A(x)).c = [], x = r + (o = e.e - t.e) + 1, i || (i = U, o = G(e.e / j) - G(t.e / j), x = x / j | 0), u = 0; N[u] == (S[u] || 0); u++) {
                ;
              }

              if (N[u] > (S[u] || 0) && o--, x < 0) g.push(1), c = !0;else {
                for (y = S.length, w = N.length, x += 2, 1 < (s = L(i / (N[u = 0] + 1))) && (N = M(N, s, i), S = M(S, s, i), w = N.length, y = S.length), m = w, d = (h = S.slice(0, w)).length; d < w; h[d++] = 0) {
                  ;
                }

                O = N.slice(), O = [0].concat(O), b = N[0], N[1] >= i / 2 && b++;

                do {
                  if (s = 0, (a = B(N, h, w, d)) < 0) {
                    if (v = h[0], w != d && (v = v * i + (h[1] || 0)), 1 < (s = L(v / b))) for (i <= s && (s = i - 1), f = (l = M(N, s, i)).length, d = h.length; 1 == B(l, h, f, d);) {
                      s--, D(l, w < f ? O : N, f, i), f = l.length, a = 1;
                    } else 0 == s && (a = s = 1), f = (l = N.slice()).length;
                    if (f < d && (l = [0].concat(l)), D(h, l, d, i), d = h.length, -1 == a) for (; B(N, h, w, d) < 1;) {
                      s++, D(h, w < d ? O : N, d, i), d = h.length;
                    }
                  } else 0 === a && (s++, h = [0]);

                  g[u++] = s, h[0] ? h[d++] = S[m] || 0 : (h = [S[m]], d = 1);
                } while ((m++ < y || null != h[0]) && x--);

                c = null != h[0], g[0] || g.splice(0, 1);
              }

              if (i == U) {
                for (u = 1, x = g[0]; 10 <= x; x /= 10, u++) {
                  ;
                }

                E(p, r + (p.e = u + o * j - 1) + 1, n, c);
              } else p.e = o, p.r = +c;

              return p;
            };
          }(), o = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, c = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, g = /^\s*\+(?=[\w.])|^\s+|\s+$/g, p = function p(e, t, r, n) {
            var i,
                a = r ? t : t.replace(g, "");
            if (l.test(a)) e.s = isNaN(a) ? null : a < 0 ? -1 : 1, e.c = e.e = null;else {
              if (!r && (a = a.replace(o, function (e, t, r) {
                return i = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != i ? e : t;
              }), n && (i = n, a = a.replace(u, "$1").replace(c, "0.$1")), t != a)) return new A(a, i);
              if (A.DEBUG) throw Error(T + "Not a" + (n ? " base " + n : "") + " number: " + t);
              e.c = e.e = e.s = null;
            }
          }, n.absoluteValue = n.abs = function () {
            var e = new A(this);
            return e.s < 0 && (e.s = 1), e;
          }, n.comparedTo = function (e, t) {
            return q(this, new A(e, t));
          }, n.decimalPlaces = n.dp = function (e, t) {
            var r, n, i;
            if (null != e) return Z(e, 0, $), null == t ? t = w : Z(t, 0, 8), E(new A(this), e + this.e + 1, t);
            if (!(r = this.c)) return null;
            if (n = ((i = r.length - 1) - G(this.e / j)) * j, i = r[i]) for (; i % 10 == 0; i /= 10, n--) {
              ;
            }
            return n < 0 && (n = 0), n;
          }, n.dividedBy = n.div = function (e, t) {
            return y(this, new A(e, t), b, w);
          }, n.dividedToIntegerBy = n.idiv = function (e, t) {
            return y(this, new A(e, t), 0, 1);
          }, n.exponentiatedBy = n.pow = function (e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l = this;
            if ((e = new A(e)).c && !e.isInteger()) throw Error(T + "Exponent not an integer: " + F(e));
            if (null != t && (t = new A(t)), o = 14 < e.e, !l.c || !l.c[0] || 1 == l.c[0] && !l.e && 1 == l.c.length || !e.c || !e.c[0]) return s = new A(Math.pow(+F(l), o ? 2 - z(e) : +F(e))), t ? s.mod(t) : s;

            if (u = e.s < 0, t) {
              if (t.c ? !t.c[0] : !t.s) return new A(NaN);
              (n = !u && l.isInteger() && t.isInteger()) && (l = l.mod(t));
            } else {
              if (9 < e.e && (0 < l.e || l.e < -1 || (0 == l.e ? 1 < l.c[0] || o && 24e7 <= l.c[1] : l.c[0] < 8e13 || o && l.c[0] <= 9999975e7))) return a = l.s < 0 && z(e) ? -0 : 0, -1 < l.e && (a = 1 / a), new A(u ? 1 / a : a);
              S && (a = _(S / j + 2));
            }

            for (c = o ? (r = new A(.5), u && (e.s = 1), z(e)) : (i = Math.abs(+F(e))) % 2, s = new A(d);;) {
              if (c) {
                if (!(s = s.times(l)).c) break;
                a ? s.c.length > a && (s.c.length = a) : n && (s = s.mod(t));
              }

              if (i) {
                if (0 === (i = L(i / 2))) break;
                c = i % 2;
              } else if (E(e = e.times(r), e.e + 1, 1), 14 < e.e) c = z(e);else {
                if (0 == (i = +F(e))) break;
                c = i % 2;
              }

              l = l.times(l), a ? l.c && l.c.length > a && (l.c.length = a) : n && (l = l.mod(t));
            }

            return n ? s : (u && (s = d.div(s)), t ? s.mod(t) : a ? E(s, S, w, void 0) : s);
          }, n.integerValue = function (e) {
            var t = new A(this);
            return null == e ? e = w : Z(e, 0, 8), E(t, t.e + 1, e);
          }, n.isEqualTo = n.eq = function (e, t) {
            return 0 === q(this, new A(e, t));
          }, n.isFinite = function () {
            return !!this.c;
          }, n.isGreaterThan = n.gt = function (e, t) {
            return 0 < q(this, new A(e, t));
          }, n.isGreaterThanOrEqualTo = n.gte = function (e, t) {
            return 1 === (t = q(this, new A(e, t))) || 0 === t;
          }, n.isInteger = function () {
            return !!this.c && G(this.e / j) > this.c.length - 2;
          }, n.isLessThan = n.lt = function (e, t) {
            return q(this, new A(e, t)) < 0;
          }, n.isLessThanOrEqualTo = n.lte = function (e, t) {
            return -1 === (t = q(this, new A(e, t))) || 0 === t;
          }, n.isNaN = function () {
            return !this.s;
          }, n.isNegative = function () {
            return this.s < 0;
          }, n.isPositive = function () {
            return 0 < this.s;
          }, n.isZero = function () {
            return !!this.c && 0 == this.c[0];
          }, n.minus = function (e, t) {
            var r,
                n,
                i,
                a,
                o = this,
                u = o.s;
            if (t = (e = new A(e, t)).s, !u || !t) return new A(NaN);
            if (u != t) return e.s = -t, o.plus(e);
            var c = o.e / j,
                s = e.e / j,
                l = o.c,
                f = e.c;

            if (!c || !s) {
              if (!l || !f) return l ? (e.s = -t, e) : new A(f ? o : NaN);
              if (!l[0] || !f[0]) return f[0] ? (e.s = -t, e) : new A(l[0] ? o : 3 == w ? -0 : 0);
            }

            if (c = G(c), s = G(s), l = l.slice(), u = c - s) {
              for ((i = (a = u < 0) ? (u = -u, l) : (s = c, f)).reverse(), t = u; t--; i.push(0)) {
                ;
              }

              i.reverse();
            } else for (n = (a = (u = l.length) < (t = f.length)) ? u : t, u = t = 0; t < n; t++) {
              if (l[t] != f[t]) {
                a = l[t] < f[t];
                break;
              }
            }

            if (a && (i = l, l = f, f = i, e.s = -e.s), 0 < (t = (n = f.length) - (r = l.length))) for (; t--; l[r++] = 0) {
              ;
            }

            for (t = U - 1; u < n;) {
              if (l[--n] < f[n]) {
                for (r = n; r && !l[--r]; l[r] = t) {
                  ;
                }

                --l[r], l[n] += U;
              }

              l[n] -= f[n];
            }

            for (; 0 == l[0]; l.splice(0, 1), --s) {
              ;
            }

            return l[0] ? D(e, l, s) : (e.s = 3 == w ? -1 : 1, e.c = [e.e = 0], e);
          }, n.modulo = n.mod = function (e, t) {
            var r,
                n,
                i = this;
            return e = new A(e, t), !i.c || !e.s || e.c && !e.c[0] ? new A(NaN) : !e.c || i.c && !i.c[0] ? new A(i) : (9 == a ? (n = e.s, e.s = 1, r = y(i, e, 0, 3), e.s = n, r.s *= n) : r = y(i, e, 0, a), (e = i.minus(r.times(e))).c[0] || 1 != a || (e.s = i.s), e);
          }, n.multipliedBy = n.times = function (e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l,
                f,
                p,
                g,
                h,
                d,
                v,
                m = this,
                y = m.c,
                b = (e = new A(e, t)).c;
            if (!(y && b && y[0] && b[0])) return !m.s || !e.s || y && !y[0] && !b || b && !b[0] && !y ? e.c = e.e = e.s = null : (e.s *= m.s, y && b ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

            for (n = G(m.e / j) + G(e.e / j), e.s *= m.s, (c = y.length) < (f = b.length) && (h = y, y = b, b = h, i = c, c = f, f = i), i = c + f, h = []; i--; h.push(0)) {
              ;
            }

            for (d = U, v = I, i = f; 0 <= --i;) {
              for (r = 0, p = b[i] % v, g = b[i] / v | 0, a = i + (o = c); i < a;) {
                r = ((s = p * (s = y[--o] % v) + (u = g * s + (l = y[o] / v | 0) * p) % v * v + h[a] + r) / d | 0) + (u / v | 0) + g * l, h[a--] = s % d;
              }

              h[a] = r;
            }

            return r ? ++n : h.splice(0, 1), D(e, h, n);
          }, n.negated = function () {
            var e = new A(this);
            return e.s = -e.s || null, e;
          }, n.plus = function (e, t) {
            var r,
                n = this,
                i = n.s;
            if (t = (e = new A(e, t)).s, !i || !t) return new A(NaN);
            if (i != t) return e.s = -t, n.minus(e);
            var a = n.e / j,
                o = e.e / j,
                u = n.c,
                c = e.c;

            if (!a || !o) {
              if (!u || !c) return new A(i / 0);
              if (!u[0] || !c[0]) return c[0] ? e : new A(u[0] ? n : 0 * i);
            }

            if (a = G(a), o = G(o), u = u.slice(), i = a - o) {
              for ((r = 0 < i ? (o = a, c) : (i = -i, u)).reverse(); i--; r.push(0)) {
                ;
              }

              r.reverse();
            }

            for ((i = u.length) - (t = c.length) < 0 && (r = c, c = u, u = r, t = i), i = 0; t;) {
              i = (u[--t] = u[t] + c[t] + i) / U | 0, u[t] = U === u[t] ? 0 : u[t] % U;
            }

            return i && (u = [i].concat(u), ++o), D(e, u, o);
          }, n.precision = n.sd = function (e, t) {
            var r, n, i;
            if (null != e && e !== !!e) return Z(e, 1, $), null == t ? t = w : Z(t, 0, 8), E(new A(this), e, t);
            if (!(r = this.c)) return null;

            if (n = (i = r.length - 1) * j + 1, i = r[i]) {
              for (; i % 10 == 0; i /= 10, n--) {
                ;
              }

              for (i = r[0]; 10 <= i; i /= 10, n++) {
                ;
              }
            }

            return e && this.e + 1 > n && (n = this.e + 1), n;
          }, n.shiftedBy = function (e) {
            return Z(e, -C, C), this.times("1e" + e);
          }, n.squareRoot = n.sqrt = function () {
            var e,
                t,
                r,
                n,
                i,
                a = this,
                o = a.c,
                u = a.s,
                c = a.e,
                s = b + 4,
                l = new A("0.5");
            if (1 !== u || !o || !o[0]) return new A(!u || u < 0 && (!o || o[0]) ? NaN : o ? a : 1 / 0);
            if ((r = 0 == (u = Math.sqrt(+F(a))) || u == 1 / 0 ? (((t = V(o)).length + c) % 2 == 0 && (t += "0"), u = Math.sqrt(+t), c = G((c + 1) / 2) - (c < 0 || c % 2), new A(t = u == 1 / 0 ? "1e" + c : (t = u.toExponential()).slice(0, t.indexOf("e") + 1) + c)) : new A(u + "")).c[0]) for ((u = (c = r.e) + s) < 3 && (u = 0);;) {
              if (i = r, r = l.times(i.plus(y(a, i, s, 1))), V(i.c).slice(0, u) === (t = V(r.c)).slice(0, u)) {
                if (r.e < c && --u, "9999" != (t = t.slice(u - 3, u + 1)) && (n || "4999" != t)) {
                  +t && (+t.slice(1) || "5" != t.charAt(0)) || (E(r, r.e + b + 2, 1), e = !r.times(r).eq(a));
                  break;
                }

                if (!n && (E(i, i.e + b + 2, 0), i.times(i).eq(a))) {
                  r = i;
                  break;
                }

                s += 4, u += 4, n = 1;
              }
            }
            return E(r, r.e + b + 1, w, e);
          }, n.toExponential = function (e, t) {
            return null != e && (Z(e, 0, $), e++), i(this, e, t, 1);
          }, n.toFixed = function (e, t) {
            return null != e && (Z(e, 0, $), e = e + this.e + 1), i(this, e, t);
          }, n.toFormat = function (e, t, r) {
            var n;
            if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = N;else if ("object" != typeof r) throw Error(T + "Argument not an object: " + r);

            if (n = this.toFixed(e, t), this.c) {
              var i,
                  a = n.split("."),
                  o = +r.groupSize,
                  u = +r.secondaryGroupSize,
                  c = r.groupSeparator || "",
                  s = a[0],
                  l = a[1],
                  f = this.s < 0,
                  p = f ? s.slice(1) : s,
                  g = p.length;

              if (u && (i = o, o = u, g -= u = i), 0 < o && 0 < g) {
                for (i = g % o || o, s = p.substr(0, i); i < g; i += o) {
                  s += c + p.substr(i, o);
                }

                0 < u && (s += c + p.slice(i)), f && (s = "-" + s);
              }

              n = l ? s + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? l.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : l) : s;
            }

            return (r.prefix || "") + n + (r.suffix || "");
          }, n.toFraction = function (e) {
            var t,
                r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l,
                f,
                p,
                g = this,
                h = g.c;
            if (null != e && (!(u = new A(e)).isInteger() && (u.c || 1 !== u.s) || u.lt(d))) throw Error(T + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + F(u));
            if (!h) return new A(g);

            for (t = new A(d), s = r = new A(d), n = c = new A(d), p = V(h), a = t.e = p.length - g.e - 1, t.c[0] = R[(o = a % j) < 0 ? j + o : o], e = !e || 0 < u.comparedTo(t) ? 0 < a ? t : s : u, o = O, O = 1 / 0, u = new A(p), c.c[0] = 0; l = y(u, t, 0, 1), 1 != (i = r.plus(l.times(n))).comparedTo(e);) {
              r = n, n = i, s = c.plus(l.times(i = s)), c = i, t = u.minus(l.times(i = t)), u = i;
            }

            return i = y(e.minus(r), n, 0, 1), c = c.plus(i.times(s)), r = r.plus(i.times(n)), c.s = s.s = g.s, f = y(s, n, a *= 2, w).minus(g).abs().comparedTo(y(c, r, a, w).minus(g).abs()) < 1 ? [s, n] : [c, r], O = o, f;
          }, n.toNumber = function () {
            return +F(this);
          }, n.toPrecision = function (e, t) {
            return null != e && Z(e, 1, $), i(this, e, t, 2);
          }, n.toString = function (e) {
            var t,
                r = this,
                n = r.s,
                i = r.e;
            return null === i ? n ? (t = "Infinity", n < 0 && (t = "-" + t)) : t = "NaN" : (t = null == e ? i <= h || v <= i ? W(V(r.c), i) : H(V(r.c), i, "0") : 10 === e ? H(V((r = E(new A(r), b + i + 1, w)).c), r.e, "0") : (Z(e, 2, M.length, "Base"), f(H(V(r.c), i, "0"), 10, e, n, !0)), n < 0 && r.c[0] && (t = "-" + t)), t;
          }, n.valueOf = n.toJSON = function () {
            return F(this);
          }, n._isBigNumber = !0, "function" == typeof Symbol && "symbol" == typeof Symbol.iterator && (n[Symbol.toStringTag] = "BigNumber", n[Symbol.for("nodejs.util.inspect.custom")] = n.valueOf), null != t && A.set(t), A;
        }()).default = t.BigNumber = t, void 0 !== r && r.exports ? r.exports = t : (e || (e = "undefined" != typeof self && self ? self : window), e.BigNumber = t);
      }(this);
    }, {}],
    2: [function (e, t, r) {
      "use strict";

      t.exports = {
        languageTag: "en-US",
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        spaceSeparated: !1,
        ordinal: function ordinal(e) {
          var t = e % 10;
          return 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
        },
        currency: {
          symbol: "$",
          position: "prefix",
          code: "USD"
        },
        currencyFormat: {
          thousandSeparated: !0,
          totalLength: 4,
          spaceSeparated: !0
        },
        formats: {
          fourDigits: {
            totalLength: 4,
            spaceSeparated: !0
          },
          fullWithTwoDecimals: {
            output: "currency",
            thousandSeparated: !0,
            mantissa: 2
          },
          fullWithTwoDecimalsNoCurrency: {
            thousandSeparated: !0,
            mantissa: 2
          },
          fullWithNoDecimals: {
            output: "currency",
            thousandSeparated: !0,
            mantissa: 0
          }
        }
      };
    }, {}],
    3: [function (e, t, r) {
      "use strict";

      function C(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var r = [],
              n = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, u = e[Symbol.iterator](); !(n = (o = u.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            i = !0, a = e;
          } finally {
            try {
              n || null == u.return || u.return();
            } finally {
              if (i) throw a;
            }
          }

          return r;
        }(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }

      var R = e("./globalState"),
          o = e("./validating"),
          u = e("./parsing"),
          n = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
          M = {
        general: {
          scale: 1024,
          suffixes: n,
          marker: "bd"
        },
        binary: {
          scale: 1024,
          suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
          marker: "b"
        },
        decimal: {
          scale: 1e3,
          suffixes: n,
          marker: "d"
        }
      },
          I = {
        totalLength: 0,
        characteristic: 0,
        forceAverage: !1,
        average: !1,
        mantissa: -1,
        optionalMantissa: !0,
        thousandSeparated: !1,
        spaceSeparated: !1,
        negative: "sign",
        forceSign: !1
      };

      function i(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
            r = 2 < arguments.length ? arguments[2] : void 0;
        if ("string" == typeof t && (t = u.parseFormat(t)), !o.validateFormat(t)) return "ERROR: invalid format";

        var n = t.prefix || "",
            i = t.postfix || "",
            a = function (e, t, r) {
          switch (t.output) {
            case "currency":
              return t = A(t, R.currentCurrencyDefaultFormat()), function (e, t, r) {
                var n = r.currentCurrency(),
                    i = Object.assign({}, I, t),
                    a = void 0,
                    o = "",
                    u = !!i.totalLength || !!i.forceAverage || i.average,
                    c = t.currencyPosition || n.position,
                    s = t.currencySymbol || n.symbol;
                i.spaceSeparated && (o = " ");
                "infix" === c && (a = o + s + o);
                var l = D({
                  instance: e,
                  providedFormat: t,
                  state: r,
                  decimalSeparator: a
                });
                "prefix" === c && (l = e._value < 0 && "sign" === i.negative ? "-".concat(o).concat(s).concat(l.slice(1)) : s + o + l);
                c && "postfix" !== c || (l = l + (o = u ? "" : o) + s);
                return l;
              }(e, t, R);

            case "percent":
              return t = A(t, R.currentPercentageDefaultFormat()), function (e, t, r, n) {
                var i = t.prefixSymbol,
                    a = D({
                  instance: n(100 * e._value),
                  providedFormat: t,
                  state: r
                }),
                    o = Object.assign({}, I, t);
                if (i) return "%".concat(o.spaceSeparated ? " " : "").concat(a);
                return "".concat(a).concat(o.spaceSeparated ? " " : "", "%");
              }(e, t, R, r);

            case "byte":
              return t = A(t, R.currentByteDefaultFormat()), h = e, v = R, m = r, y = (d = t).base || "binary", b = M[y], w = B(h._value, b.suffixes, b.scale), O = w.value, x = w.suffix, S = D({
                instance: m(O),
                providedFormat: d,
                state: v,
                defaults: v.currentByteDefaultFormat()
              }), N = v.currentAbbreviations(), "".concat(S).concat(N.spaced ? " " : "").concat(x);

            case "time":
              return t = A(t, R.currentTimeDefaultFormat()), l = e, f = Math.floor(l._value / 60 / 60), p = Math.floor((l._value - 60 * f * 60) / 60), g = Math.round(l._value - 60 * f * 60 - 60 * p), "".concat(f, ":").concat(p < 10 ? "0" : "").concat(p, ":").concat(g < 10 ? "0" : "").concat(g);

            case "ordinal":
              return t = A(t, R.currentOrdinalDefaultFormat()), n = e, i = t, o = (a = R).currentOrdinal(), u = Object.assign({}, I, i), c = D({
                instance: n,
                providedFormat: i,
                state: a
              }), s = o(n._value), "".concat(c).concat(u.spaceSeparated ? " " : "").concat(s);

            case "number":
            default:
              return D({
                instance: e,
                providedFormat: t,
                numbro: r
              });
          }

          var n, i, a, o, u, c, s;
          var l, f, p, g;
          var h, d, v, m, y, b, w, O, x, S, N;
        }(e, t, r);

        return a = (a = n + a) + i;
      }

      function B(e, t, r) {
        var n = t[0],
            i = Math.abs(e);

        if (r <= i) {
          for (var a = 1; a < t.length; ++a) {
            var o = Math.pow(r, a),
                u = Math.pow(r, a + 1);

            if (o <= i && i < u) {
              n = t[a], e /= o;
              break;
            }
          }

          n === t[0] && (e /= Math.pow(r, t.length - 1), n = t[t.length - 1]);
        }

        return {
          value: e,
          suffix: n
        };
      }

      function p(e) {
        for (var t = "", r = 0; r < e; r++) {
          t += "0";
        }

        return t;
      }

      function $(e, t) {
        return -1 !== e.toString().indexOf("e") ? function (e, t) {
          var r = e.toString(),
              n = C(r.split("e"), 2),
              i = n[0],
              a = n[1],
              o = C(i.split("."), 2),
              u = o[0],
              c = o[1],
              s = void 0 === c ? "" : c;
          if (0 < +a) r = u + s + p(a - s.length);else {
            var l = ".";
            l = +u < 0 ? "-0".concat(l) : "0".concat(l);
            var f = (p(-a - 1) + Math.abs(u) + s).substr(0, t);
            f.length < t && (f += p(t - f.length)), r = l + f;
          }
          return 0 < +a && 0 < t && (r += ".".concat(p(t))), r;
        }(e, t) : (Math.round(+"".concat(e, "e+").concat(t)) / Math.pow(10, t)).toFixed(t);
      }

      function D(e) {
        var t = e.instance,
            r = e.providedFormat,
            n = e.state,
            i = void 0 === n ? R : n,
            a = e.decimalSeparator,
            o = e.defaults,
            u = void 0 === o ? i.currentDefaults() : o,
            c = t._value;
        if (0 === c && i.hasZeroFormat()) return i.getZeroFormat();
        if (!isFinite(c)) return c.toString();
        var s,
            l,
            f,
            p,
            g,
            h,
            d,
            v,
            m = Object.assign({}, I, u, r),
            y = m.totalLength,
            b = y ? 0 : m.characteristic,
            w = m.optionalCharacteristic,
            O = m.forceAverage,
            x = !!y || !!O || m.average,
            S = y ? -1 : x && void 0 === r.mantissa ? 0 : m.mantissa,
            N = !y && (void 0 === r.optionalMantissa ? -1 === S : m.optionalMantissa),
            M = m.trimMantissa,
            B = m.thousandSeparated,
            D = m.spaceSeparated,
            A = m.negative,
            E = m.forceSign,
            F = m.exponential,
            k = "";

        if (x) {
          var _ = function (e) {
            var t = e.value,
                r = e.forceAverage,
                n = e.abbreviations,
                i = e.spaceSeparated,
                a = void 0 !== i && i,
                o = e.totalLength,
                u = void 0 === o ? 0 : o,
                c = "",
                s = Math.abs(t),
                l = -1;

            if (s >= Math.pow(10, 12) && !r || "trillion" === r ? (c = n.trillion, t /= Math.pow(10, 12)) : s < Math.pow(10, 12) && s >= Math.pow(10, 9) && !r || "billion" === r ? (c = n.billion, t /= Math.pow(10, 9)) : s < Math.pow(10, 9) && s >= Math.pow(10, 6) && !r || "million" === r ? (c = n.million, t /= Math.pow(10, 6)) : (s < Math.pow(10, 6) && s >= Math.pow(10, 3) && !r || "thousand" === r) && (c = n.thousand, t /= Math.pow(10, 3)), c && (c = (a ? " " : "") + c), u) {
              var f = t.toString().split(".")[0];
              l = Math.max(u - f.length, 0);
            }

            return {
              value: t,
              abbreviation: c,
              mantissaPrecision: l
            };
          }({
            value: c,
            forceAverage: O,
            abbreviations: i.currentAbbreviations(),
            spaceSeparated: D,
            totalLength: y
          });

          c = _.value, k += _.abbreviation, y && (S = _.mantissaPrecision);
        }

        if (F) {
          var L = (l = (s = {
            value: c,
            characteristicPrecision: b
          }).value, f = s.characteristicPrecision, p = void 0 === f ? 0 : f, g = C(l.toExponential().split("e"), 2), h = g[0], d = g[1], v = +h, p && 1 < p && (v *= Math.pow(10, p - 1), d = 0 <= (d = +d - (p - 1)) ? "+".concat(d) : d), {
            value: v,
            abbreviation: "e".concat(d)
          });
          c = L.value, k = L.abbreviation + k;
        }

        var T,
            P,
            U,
            j = function (e, t, r, n, i) {
          if (-1 === n) return e;
          var a = $(t, n),
              o = C(a.toString().split("."), 2),
              u = o[0],
              c = o[1],
              s = void 0 === c ? "" : c;
          if (s.match(/^0+$/) && (r || i)) return u;
          var l = s.match(/0+$/);
          return i && l ? "".concat(u, ".").concat(s.toString().slice(0, l.index)) : a.toString();
        }(c.toString(), c, N, S, M);

        return j = function (e, t, r, n, i) {
          var a = n.currentDelimiters(),
              o = a.thousands;
          i = i || a.decimal;
          var u = a.thousandsSize || 3,
              c = e.toString(),
              s = c.split(".")[0],
              l = c.split(".")[1];
          return r && (t < 0 && (s = s.slice(1)), function (e, t) {
            for (var r = [], n = 0, i = e; 0 < i; i--) {
              n === t && (r.unshift(i), n = 0), n++;
            }

            return r;
          }(s.length, u).forEach(function (e, t) {
            s = s.slice(0, e + t) + o + s.slice(e + t);
          }), t < 0 && (s = "-".concat(s))), c = l ? s + i + l : s;
        }(j = function (e, t, r, n) {
          var i = e,
              a = C(i.toString().split("."), 2),
              o = a[0],
              u = a[1];
          if (o.match(/^-?0$/) && r) return u ? "".concat(o.replace("0", ""), ".").concat(u) : o.replace("0", "");
          if (o.length < n) for (var c = n - o.length, s = 0; s < c; s++) {
            i = "0".concat(i);
          }
          return i.toString();
        }(j, 0, w, b), c, B, i, a), (x || F) && (j = j + k), (E || c < 0) && (T = j, U = A, j = 0 === (P = c) ? T : 0 == +T ? T.replace("-", "") : 0 < P ? "+".concat(T) : "sign" === U ? T : "(".concat(T.replace("-", ""), ")")), j;
      }

      function A(e, t) {
        if (!e) return t;
        var r = Object.keys(e);
        return 1 === r.length && "output" === r[0] ? t : e;
      }

      t.exports = function (n) {
        return {
          format: function format() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return i.apply(void 0, t.concat([n]));
          },
          getByteUnit: function getByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = M.general;
              return B(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          getBinaryByteUnit: function getBinaryByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = M.binary;
              return B(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          getDecimalByteUnit: function getDecimalByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = M.decimal;
              return B(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          formatOrDefault: A
        };
      };
    }, {
      "./globalState": 4,
      "./parsing": 8,
      "./validating": 10
    }],
    4: [function (e, t, r) {
      "use strict";

      var i = e("./en-US"),
          n = e("./validating"),
          a = e("./parsing"),
          o = {},
          u = void 0,
          c = {},
          s = null,
          l = {};

      function f(e) {
        u = e;
      }

      function p() {
        return c[u];
      }

      o.languages = function () {
        return Object.assign({}, c);
      }, o.currentLanguage = function () {
        return u;
      }, o.currentCurrency = function () {
        return p().currency;
      }, o.currentAbbreviations = function () {
        return p().abbreviations;
      }, o.currentDelimiters = function () {
        return p().delimiters;
      }, o.currentOrdinal = function () {
        return p().ordinal;
      }, o.currentDefaults = function () {
        return Object.assign({}, p().defaults, l);
      }, o.currentOrdinalDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), p().ordinalFormat);
      }, o.currentByteDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), p().byteFormat);
      }, o.currentPercentageDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), p().percentageFormat);
      }, o.currentCurrencyDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), p().currencyFormat);
      }, o.currentTimeDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), p().timeFormat);
      }, o.setDefaults = function (e) {
        e = a.parseFormat(e), n.validateFormat(e) && (l = e);
      }, o.getZeroFormat = function () {
        return s;
      }, o.setZeroFormat = function (e) {
        return s = "string" == typeof e ? e : null;
      }, o.hasZeroFormat = function () {
        return null !== s;
      }, o.languageData = function (e) {
        if (e) {
          if (c[e]) return c[e];
          throw new Error('Unknown tag "'.concat(e, '"'));
        }

        return p();
      }, o.registerLanguage = function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
        if (!n.validateLanguage(e)) throw new Error("Invalid language data");
        c[e.languageTag] = e, t && f(e.languageTag);
      }, o.setLanguage = function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : i.languageTag;

        if (!c[e]) {
          var r = e.split("-")[0],
              n = Object.keys(c).find(function (e) {
            return e.split("-")[0] === r;
          });
          return c[n] ? void f(n) : void f(t);
        }

        f(e);
      }, o.registerLanguage(i), u = i.languageTag, t.exports = o;
    }, {
      "./en-US": 2,
      "./parsing": 8,
      "./validating": 10
    }],
    5: [function (n, e, t) {
      "use strict";

      e.exports = function (t) {
        return {
          loadLanguagesInNode: function loadLanguagesInNode(e) {
            return r = t, void e.forEach(function (t) {
              var e = void 0;

              try {
                e = n("../languages/".concat(t));
              } catch (e) {
                console.error('Unable to load "'.concat(t, '". No matching language file found.'));
              }

              e && r.registerLanguage(e);
            });
            var r;
          }
        };
      };
    }, {}],
    6: [function (e, t, r) {
      "use strict";

      var c = e("bignumber.js");

      function a(e, t, r) {
        var n = new c(e._value),
            i = t;
        return r.isNumbro(t) && (i = t._value), i = new c(i), e._value = n.minus(i).toNumber(), e;
      }

      t.exports = function (u) {
        return {
          add: function add(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.plus(o).toNumber(), r;
            var r, n, i, a, o;
          },
          subtract: function subtract(e, t) {
            return a(e, t, u);
          },
          multiply: function multiply(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.times(o).toNumber(), r;
            var r, n, i, a, o;
          },
          divide: function divide(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.dividedBy(o).toNumber(), r;
            var r, n, i, a, o;
          },
          set: function set(e, t) {
            return r = e, i = n = t, u.isNumbro(n) && (i = n._value), r._value = i, r;
            var r, n, i;
          },
          difference: function difference(e, t) {
            return r = t, a(i = (n = u)(e._value), r, n), Math.abs(i._value);
            var r, n, i;
          }
        };
      };
    }, {
      "bignumber.js": 1
    }],
    7: [function (e, t, r) {
      "use strict";

      function i(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var a = e("./globalState"),
          n = e("./validating"),
          o = e("./loading")(g),
          u = e("./unformatting"),
          c = e("./formatting")(g),
          s = e("./manipulating")(g),
          l = e("./parsing"),
          f = function () {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this._value = e;
        }

        var e, r, n;
        return e = t, (r = [{
          key: "clone",
          value: function value() {
            return g(this._value);
          }
        }, {
          key: "format",
          value: function value() {
            var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
            return c.format(this, e);
          }
        }, {
          key: "formatCurrency",
          value: function value(e) {
            return "string" == typeof e && (e = l.parseFormat(e)), (e = c.formatOrDefault(e, a.currentCurrencyDefaultFormat())).output = "currency", c.format(this, e);
          }
        }, {
          key: "formatTime",
          value: function value() {
            var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
            return e.output = "time", c.format(this, e);
          }
        }, {
          key: "binaryByteUnits",
          value: function value() {
            return c.getBinaryByteUnit(this);
          }
        }, {
          key: "decimalByteUnits",
          value: function value() {
            return c.getDecimalByteUnit(this);
          }
        }, {
          key: "byteUnits",
          value: function value() {
            return c.getByteUnit(this);
          }
        }, {
          key: "difference",
          value: function value(e) {
            return s.difference(this, e);
          }
        }, {
          key: "add",
          value: function value(e) {
            return s.add(this, e);
          }
        }, {
          key: "subtract",
          value: function value(e) {
            return s.subtract(this, e);
          }
        }, {
          key: "multiply",
          value: function value(e) {
            return s.multiply(this, e);
          }
        }, {
          key: "divide",
          value: function value(e) {
            return s.divide(this, e);
          }
        }, {
          key: "set",
          value: function value(e) {
            return s.set(this, p(e));
          }
        }, {
          key: "value",
          value: function value() {
            return this._value;
          }
        }, {
          key: "valueOf",
          value: function value() {
            return this._value;
          }
        }]) && i(e.prototype, r), n && i(e, n), t;
      }();

      function p(e) {
        var t = e;
        return g.isNumbro(e) ? t = e._value : "string" == typeof e ? t = g.unformat(e) : isNaN(e) && (t = NaN), t;
      }

      function g(e) {
        return new f(p(e));
      }

      g.version = "2.1.2", g.isNumbro = function (e) {
        return e instanceof f;
      }, g.language = a.currentLanguage, g.registerLanguage = a.registerLanguage, g.setLanguage = a.setLanguage, g.languages = a.languages, g.languageData = a.languageData, g.zeroFormat = a.setZeroFormat, g.defaultFormat = a.currentDefaults, g.setDefaults = a.setDefaults, g.defaultCurrencyFormat = a.currentCurrencyDefaultFormat, g.validate = n.validate, g.loadLanguagesInNode = o.loadLanguagesInNode, g.unformat = u.unformat, t.exports = g;
    }, {
      "./formatting": 3,
      "./globalState": 4,
      "./loading": 5,
      "./manipulating": 6,
      "./parsing": 8,
      "./unformatting": 9,
      "./validating": 10
    }],
    8: [function (e, t, r) {
      "use strict";

      t.exports = {
        parseFormat: function parseFormat(e) {
          var t,
              r,
              n,
              i,
              a,
              o,
              u,
              c,
              s,
              l,
              f,
              p,
              g,
              h,
              d,
              v,
              m,
              y,
              b,
              w,
              O = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" != typeof e ? e : (r = O, e = (n = (t = e).match(/^{([^}]*)}/)) ? (r.prefix = n[1], t.slice(n[0].length)) : t, a = O, function (e, t) {
            if (-1 === e.indexOf("$")) {
              if (-1 === e.indexOf("%")) return -1 !== e.indexOf("bd") ? (t.output = "byte", t.base = "general") : -1 !== e.indexOf("b") ? (t.output = "byte", t.base = "binary") : -1 !== e.indexOf("d") ? (t.output = "byte", t.base = "decimal") : -1 === e.indexOf(":") ? -1 !== e.indexOf("o") && (t.output = "ordinal") : t.output = "time";
              t.output = "percent";
            } else t.output = "currency";
          }(e = (o = (i = e).match(/{([^}]*)}$/)) ? (a.postfix = o[1], i.slice(0, -o[0].length)) : i, O), u = O, (c = e.match(/[1-9]+[0-9]*/)) && (u.totalLength = +c[0]), s = O, (l = e.split(".")[0].match(/0+/)) && (s.characteristic = l[0].length), function (e, t) {
            if (-1 !== e.indexOf(".")) {
              var r = e.split(".")[0];
              t.optionalCharacteristic = -1 === r.indexOf("0");
            }
          }(e, O), f = O, -1 !== e.indexOf("a") && (f.average = !0), g = O, -1 !== (p = e).indexOf("K") ? g.forceAverage = "thousand" : -1 !== p.indexOf("M") ? g.forceAverage = "million" : -1 !== p.indexOf("B") ? g.forceAverage = "billion" : -1 !== p.indexOf("T") && (g.forceAverage = "trillion"), function (e, t) {
            var r = e.split(".")[1];

            if (r) {
              var n = r.match(/0+/);
              n && (t.mantissa = n[0].length);
            }
          }(e, O), d = O, (h = e).match(/\[\.]/) ? d.optionalMantissa = !0 : h.match(/\./) && (d.optionalMantissa = !1), v = O, -1 !== e.indexOf(",") && (v.thousandSeparated = !0), m = O, -1 !== e.indexOf(" ") && (m.spaceSeparated = !0), b = O, (y = e).match(/^\+?\([^)]*\)$/) && (b.negative = "parenthesis"), y.match(/^\+?-/) && (b.negative = "sign"), w = O, e.match(/^\+/) && (w.forceSign = !0), O);
        }
      };
    }, {}],
    9: [function (p, e, t) {
      "use strict";

      var O = [{
        key: "ZiB",
        factor: Math.pow(1024, 7)
      }, {
        key: "ZB",
        factor: Math.pow(1e3, 7)
      }, {
        key: "YiB",
        factor: Math.pow(1024, 8)
      }, {
        key: "YB",
        factor: Math.pow(1e3, 8)
      }, {
        key: "TiB",
        factor: Math.pow(1024, 4)
      }, {
        key: "TB",
        factor: Math.pow(1e3, 4)
      }, {
        key: "PiB",
        factor: Math.pow(1024, 5)
      }, {
        key: "PB",
        factor: Math.pow(1e3, 5)
      }, {
        key: "MiB",
        factor: Math.pow(1024, 2)
      }, {
        key: "MB",
        factor: Math.pow(1e3, 2)
      }, {
        key: "KiB",
        factor: Math.pow(1024, 1)
      }, {
        key: "KB",
        factor: Math.pow(1e3, 1)
      }, {
        key: "GiB",
        factor: Math.pow(1024, 3)
      }, {
        key: "GB",
        factor: Math.pow(1e3, 3)
      }, {
        key: "EiB",
        factor: Math.pow(1024, 6)
      }, {
        key: "EB",
        factor: Math.pow(1e3, 6)
      }, {
        key: "B",
        factor: 1
      }];

      function x(e) {
        return e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      function g(e, t) {
        var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "",
            n = 3 < arguments.length ? arguments[3] : void 0,
            i = 4 < arguments.length ? arguments[4] : void 0,
            a = 5 < arguments.length ? arguments[5] : void 0,
            o = 6 < arguments.length ? arguments[6] : void 0;
        if ("" !== e) return e === i ? 0 : function e(t, r) {
          var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "",
              i = 3 < arguments.length ? arguments[3] : void 0,
              a = 4 < arguments.length ? arguments[4] : void 0,
              o = 5 < arguments.length ? arguments[5] : void 0,
              u = 6 < arguments.length ? arguments[6] : void 0;
          if (!isNaN(+t)) return +t;
          var c = "",
              s = t.replace(/(^[^(]*)\((.*)\)([^)]*$)/, "$1$2$3");
          if (s !== t) return -1 * e(s, r, n, i, a, o, u);

          for (var l = 0; l < O.length; l++) {
            var f = O[l];
            if ((c = t.replace(f.key, "")) !== t) return e(c, r, n, i, a, o, u) * f.factor;
          }

          if ((c = t.replace("%", "")) !== t) return e(c, r, n, i, a, o, u) / 100;
          var p = parseFloat(t);

          if (!isNaN(p)) {
            var g = i(p);
            if (g && "." !== g && (c = t.replace(new RegExp("".concat(x(g), "$")), "")) !== t) return e(c, r, n, i, a, o, u);
            var h = {};
            Object.keys(o).forEach(function (e) {
              h[o[e]] = e;
            });

            for (var d = Object.keys(h).sort().reverse(), v = d.length, m = 0; m < v; m++) {
              var y = d[m],
                  b = h[y];

              if ((c = t.replace(y, "")) !== t) {
                var w = void 0;

                switch (b) {
                  case "thousand":
                    w = Math.pow(10, 3);
                    break;

                  case "million":
                    w = Math.pow(10, 6);
                    break;

                  case "billion":
                    w = Math.pow(10, 9);
                    break;

                  case "trillion":
                    w = Math.pow(10, 12);
                }

                return e(c, r, n, i, a, o, u) * w;
              }
            }
          }
        }(function (e, t) {
          var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "",
              n = e.replace(r, "");
          return n = (n = n.replace(new RegExp("([0-9])".concat(x(t.thousands), "([0-9])"), "g"), "$1$2")).replace(t.decimal, ".");
        }(e, t, r), t, r, n, i, a, o);
      }

      e.exports = {
        unformat: function unformat(e, t) {
          var r,
              n,
              i,
              a = p("./globalState"),
              o = a.currentDelimiters(),
              u = a.currentCurrency().symbol,
              c = a.currentOrdinal(),
              s = a.getZeroFormat(),
              l = a.currentAbbreviations(),
              f = void 0;
          if ("string" == typeof e) f = function (e, t) {
            if (!e.indexOf(":") || ":" === t.thousands) return !1;
            var r = e.split(":");
            if (3 !== r.length) return !1;
            var n = +r[0],
                i = +r[1],
                a = +r[2];
            return !isNaN(n) && !isNaN(i) && !isNaN(a);
          }(e, o) ? (r = e.split(":"), n = +r[0], i = +r[1], +r[2] + 60 * i + 3600 * n) : g(e, o, u, c, s, l, t);else {
            if ("number" != typeof e) return;
            f = e;
          }
          if (void 0 !== f) return f;
        }
      };
    }, {
      "./globalState": 4
    }],
    10: [function (e, t, r) {
      "use strict";

      function n(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, r = new Array(e.length); t < e.length; t++) {
              r[t] = e[t];
            }

            return r;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }

      function f(e) {
        return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      var i = e("./unformatting"),
          a = /^[a-z]{2,3}(-[a-zA-Z]{4})?(-([A-Z]{2}|[0-9]{3}))?$/,
          p = {
        output: {
          type: "string",
          validValues: ["currency", "percent", "byte", "time", "ordinal", "number"]
        },
        base: {
          type: "string",
          validValues: ["decimal", "binary", "general"],
          restriction: function restriction(e, t) {
            return "byte" === t.output;
          },
          message: "`base` must be provided only when the output is `byte`",
          mandatory: function mandatory(e) {
            return "byte" === e.output;
          }
        },
        characteristic: {
          type: "number",
          restriction: function restriction(e) {
            return 0 <= e;
          },
          message: "value must be positive"
        },
        prefix: "string",
        postfix: "string",
        forceAverage: {
          type: "string",
          validValues: ["trillion", "billion", "million", "thousand"]
        },
        average: "boolean",
        currencyPosition: {
          type: "string",
          validValues: ["prefix", "infix", "postfix"]
        },
        currencySymbol: "string",
        totalLength: {
          type: "number",
          restrictions: [{
            restriction: function restriction(e) {
              return 0 <= e;
            },
            message: "value must be positive"
          }, {
            restriction: function restriction(e, t) {
              return !t.exponential;
            },
            message: "`totalLength` is incompatible with `exponential`"
          }]
        },
        mantissa: {
          type: "number",
          restriction: function restriction(e) {
            return 0 <= e;
          },
          message: "value must be positive"
        },
        optionalMantissa: "boolean",
        trimMantissa: "boolean",
        optionalCharacteristic: "boolean",
        thousandSeparated: "boolean",
        spaceSeparated: "boolean",
        abbreviations: {
          type: "object",
          children: {
            thousand: "string",
            million: "string",
            billion: "string",
            trillion: "string"
          }
        },
        negative: {
          type: "string",
          validValues: ["sign", "parenthesis"]
        },
        forceSign: "boolean",
        exponential: {
          type: "boolean"
        },
        prefixSymbol: {
          type: "boolean",
          restriction: function restriction(e, t) {
            return "percent" === t.output;
          },
          message: "`prefixSymbol` can be provided only when the output is `percent`"
        }
      },
          o = {
        languageTag: {
          type: "string",
          mandatory: !0,
          restriction: function restriction(e) {
            return e.match(a);
          },
          message: "the language tag must follow the BCP 47 specification (see https://tools.ieft.org/html/bcp47)"
        },
        delimiters: {
          type: "object",
          children: {
            thousands: "string",
            decimal: "string",
            thousandsSize: "number"
          },
          mandatory: !0
        },
        abbreviations: {
          type: "object",
          children: {
            thousand: {
              type: "string",
              mandatory: !0
            },
            million: {
              type: "string",
              mandatory: !0
            },
            billion: {
              type: "string",
              mandatory: !0
            },
            trillion: {
              type: "string",
              mandatory: !0
            }
          },
          mandatory: !0
        },
        spaceSeparated: "boolean",
        ordinal: {
          type: "function",
          mandatory: !0
        },
        currency: {
          type: "object",
          children: {
            symbol: "string",
            position: "string",
            code: "string"
          },
          mandatory: !0
        },
        defaults: "format",
        ordinalFormat: "format",
        byteFormat: "format",
        percentageFormat: "format",
        currencyFormat: "format",
        timeDefaults: "format",
        formats: {
          type: "object",
          children: {
            fourDigits: {
              type: "format",
              mandatory: !0
            },
            fullWithTwoDecimals: {
              type: "format",
              mandatory: !0
            },
            fullWithTwoDecimalsNoCurrency: {
              type: "format",
              mandatory: !0
            },
            fullWithNoDecimals: {
              type: "format",
              mandatory: !0
            }
          }
        }
      };

      function u(e) {
        return !!i.unformat(e);
      }

      function g(c, s, l) {
        var e = 3 < arguments.length && void 0 !== arguments[3] && arguments[3],
            t = Object.keys(c).map(function (e) {
          if (!s[e]) return console.error("".concat(l, " Invalid key: ").concat(e)), !1;
          var t = c[e],
              r = s[e];

          if ("string" == typeof r && (r = {
            type: r
          }), "format" === r.type) {
            if (!g(t, p, "[Validate ".concat(e, "]"), !0)) return !1;
          } else if (f(t) !== r.type) return console.error("".concat(l, " ").concat(e, ' type mismatched: "').concat(r.type, '" expected, "').concat(f(t), '" provided')), !1;

          if (r.restrictions && r.restrictions.length) for (var n = r.restrictions.length, i = 0; i < n; i++) {
            var a = r.restrictions[i],
                o = a.restriction,
                u = a.message;
            if (!o(t, c)) return console.error("".concat(l, " ").concat(e, " invalid value: ").concat(u)), !1;
          }
          if (r.restriction && !r.restriction(t, c)) return console.error("".concat(l, " ").concat(e, " invalid value: ").concat(r.message)), !1;
          if (r.validValues && -1 === r.validValues.indexOf(t)) return console.error("".concat(l, " ").concat(e, " invalid value: must be among ").concat(JSON.stringify(r.validValues), ', "').concat(t, '" provided')), !1;
          if (r.children && !g(t, r.children, "[Validate ".concat(e, "]"))) return !1;
          return !0;
        });
        return e || t.push.apply(t, n(Object.keys(s).map(function (e) {
          var t = s[e];

          if ("string" == typeof t && (t = {
            type: t
          }), t.mandatory) {
            var r = t.mandatory;
            if ("function" == typeof r && (r = r(c)), r && void 0 === c[e]) return console.error("".concat(l, ' Missing mandatory key "').concat(e, '"')), !1;
          }

          return !0;
        }))), t.reduce(function (e, t) {
          return e && t;
        }, !0);
      }

      function c(e) {
        return g(e, p, "[Validate format]");
      }

      t.exports = {
        validate: function validate(e, t) {
          var r = u(e),
              n = c(t);
          return r && n;
        },
        validateFormat: c,
        validateInput: u,
        validateLanguage: function validateLanguage(e) {
          return g(e, o, "[Validate language]");
        }
      };
    }, {
      "./unformatting": 9
    }]
  }, {}, [7])(7);
});